import { redirect } from "react-router-dom";
import { store } from "../../redux/store";
import { fullSessionCheck } from "../../utils/session";
 
export const authLoader = async ({ request }: any) => {
  const url = new URL(request.url);  
  if (
    url.pathname.includes("/invalidUser") ||
    url.pathname.includes("/sessionexpired")
  ) {
    return null;
  }  
  const { dispatch, getState } = store;
  const skip = sessionStorage.getItem("skipSessionCheck");
  const state = getState();
  if (state.header.invalidATMSUser) {
    return null;
  }
  if (skip === "true") {
   // sessionStorage.removeItem("skipSessionCheck");
    return null;
  }
  const result = await fullSessionCheck(dispatch, getState);
  if (result.isExpired) {
    throw redirect("/sessionexpired");
  }
 
  return null;
};
 
 